<div *ngIf="visibleFrom2025">
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [isBlueText] = "isBlueText" [labelClass]="isSpanish ? 'blue-text' : ''"[label]=" isSpanish ? '¿Tiene el Solicitante una persona (es decir, agentes,
                    corredores, consejeros de SHIP, familiares u otros terceros) que ayude a alguien a completar este
                    formulario (pero que no esté autorizado a tomar decisiones en nombre del inscrito)?' : 'Does the Applicant have an individual(i.e. agents, brokers, SHIP counselors, family members, or
                    other third parties) helping somone fill out this form (but not authorized to make decisions on
                    behalf of the enrollee)?'" [options]="rblAppIndIND"
                    [selectedValue]="enrollmentindvrepViewModel.INDREPIND" (onValueChange)="rblAppIndINDClick($event)"
                    [radioGroupName]="'rblAppIndIND'" [disabled]="isDisabled">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <div *ngIf="isAppIndTitle" class="row">
        <div class="col-16">
            <p *ngIf="enrollmentindvrepViewModel.INDREPIND === 'No'" class="qtip-note">
                <strong>IF NO:</strong> Please proceed to the next question.
            </p>
            <p *ngIf="isAppInd" class="qtip-note">
                <strong>IF YES:</strong>
                <label class="blue-text">What is the name of the Individual and Relationship to Enrollee?</label>
            </p>
        </div>
    </div>
    <div *ngIf="isAppInd">
        <fieldset>
            <legend>{{ isSpanish ? '¿Tiene el Solicitante una persona (es decir, agentes, corredores, consejeros de SHIP, familiares u otros terceros) que ayude a alguien a completar este formulario (pero que no esté autorizado a tomar decisiones en nombre del inscrito)?' : 'Does the Applicant have an individual(i.e. agents, brokers, SHIP counselors, family members, or other third parties) helping somone fill out this form (but not authorized to make decisions on behalf of the enrollee)?' }}</legend>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                       <ValidatedTextField [label]="isSpanish ? 'Nombre' : 'Name'"
                            id="indvrep-name-text"
                            [text]="enrollmentindvrepViewModel.INDREPNAME"
                            (onValueChange)="enrollmentindvrepViewModel.INDREPNAME = $event"
                            [validators]="[notBlankValidator]">
                        </ValidatedTextField>
                    </div>
                </div>

                <div class="col-6">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                            [label]="isSpanish ? 'Relación con la inscrita' : 'Relationship to enrollee'"
                            [id]="indvrep-reltoenroll-dropdown"
                            [text]="enrollmentindvrepViewModel.RELTOENROLL"
                            [disabled]="'false'" [selectedValue]="enrollmentindvrepViewModel.RELTOENROLL"
                            (onValueChange)="relToEnrollonValueChange($event)" [options]="rblReltoEnroll"
                            aria-label="Relationship to enrollee" for="RELTOENROLL">
                        </ValidatedDropDown>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper" *ngIf="isNPNmandatory">
                        <ValidatedTextField [label]="'NPN'" id="npn-mandatory-txt" [text]="enrollmentindvrepViewModel.NPN" [maxlength]="10"
                            (onValueChange)="enrollmentindvrepViewModel.NPN = $event" [validators]="[notBlankValidator]">
                        </ValidatedTextField>
                    </div>
                    <div class="input-wrapper" *ngIf="!isNPNmandatory">
                        <ValidatedTextField [label]="isSpanish ? 'NPN (opcional)' : 'NPN (optional)'"
                        id="npn-optional-txt"
                        [text]="enrollmentindvrepViewModel.NPN" [maxlength]="10"
                            (onValueChange)="enrollmentindvrepViewModel.NPN = $event">
                        </ValidatedTextField>
                    </div>

                </div>

            </div>
        </fieldset>
    </div>
</div>